module.exports = __webpack_public_path__ + "img/pic_banner_logo@2x.7fea0c89.png";